/**
 * Canonical Role Slug Sets
 *
 * Single source of truth for staff/admin role classification.
 * Importable from both client and server code (no server dependencies).
 *
 * NOTE: These sets are for DB-backed role slugs used in role assignments.
 * They cover BOTH slug conventions: 'admin-platform' (legacy JWT metadata)
 * and 'platform-admin' (DB-seeded slug). Platform admin status can also
 * come from user_settings_permissions — always check isPlatformAdmin /
 * is_platform_admin flags in addition to role slugs.
 */

export const STAFF_ROLE_SLUGS = new Set([
  'officer', 'admin', 'supervisor', 'agent',
  'admin-platform', 'admin-tenant',
  'platform-admin',  // DB-seeded slug (vs 'admin-platform' in JWT metadata)
  'executive', 'owner', 'training-coordinator',
  'member', 'trainee',  // DB roles mapped from legacy 'officer'
]);

export const ADMIN_ROLE_SLUGS = new Set([
  'admin', 'admin-platform', 'admin-tenant',
  'platform-admin',  // DB-seeded slug
  'executive', 'owner',
]);
